export default "__VITE_ASSET__CjXuZedX__"